(function () {
  'use strict';

  var configuratorRoot = document.querySelector('[data-custom-chopstick-configurator-root]');
  if (!configuratorRoot || configuratorRoot.configuratorProfessionalTemplates) return;

  var TEMPLATE_VERSION = 1;
  var PAGE_WIDTH = 841.89;
  var PAGE_HEIGHT = 595.275;
  var CROP_SCALE = 2;
  var sourcePromises = {};
  var cropPromises = {};

  function clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function text(value, x, y, width, fontSize, fontFamily, fill, options) {
    options = options || {};
    var lineCount = String(value).split('\n').length;
    var height = Math.max(.12, fontSize * lineCount * 1.04);
    return {
      type: 'text',
      role: options.role || 'professional-text',
      frame: { x: x - width / 2, y: y - height / 2, width: width, height: height },
      rotation: options.rotation || 0,
      content: { kind: 'literal', value: value },
      style: {
        fontFamily: fontFamily,
        fontWeight: options.bold ? 700 : 400,
        fontStyle: options.italic ? 'italic' : 'normal',
        fontSize: fontSize,
        lineHeight: 1,
        letterSpacing: options.letterSpacing || 0,
        fill: fill,
        align: options.align || 'center',
        fit: 'fixed',
        wrap: 'none',
        paddingX: 0,
        paddingY: 0
      }
    };
  }

  function vector(sourceId, crop, x, y, width, height, name, options) {
    options = options || {};
    return {
      type: 'image',
      role: 'professional-artwork',
      frame: { x: x - width / 2, y: y - height / 2, width: width, height: height },
      rotation: options.rotation || 0,
      assetRef: {
        kind: 'template',
        templateId: '',
        sourceId: sourceId,
        crop: crop.slice()
      },
      style: { fit: 'fill', align: 'center', padding: 0, opacity: 1 },
      label: name
    };
  }

  var definitions = {
    classic: {
      sourceId: 'classic',
      label: 'Classic',
      description: 'The authored Sushi Planet identity, contact, and online-order composition.',
      front: {
        background: '#ffffff',
        objects: [
          vector('classic', [102, 247, 128, 54], .16, .47, .17, .5, 'Sushi Planet logo'),
          text('(805) 523-2954', .52, .48, .28, .16, 'Courier New, monospace', '#202020', { letterSpacing: .018 }),
          vector('classic', [636, 250, 119, 47], .84, .47, .15, .48, 'Social contact artwork')
        ]
      },
      back: {
        background: '#ffffff',
        objects: [
          text('www.sushiplanetmoorpark.com', .17, .22, .27, .09, 'Arial, sans-serif', '#202020', { rotation: 180 }),
          text('(805) 523-2954', .17, .41, .19, .09, 'Georgia, serif', '#202020', { rotation: 180 }),
          text('Suite # A', .17, .57, .13, .085, 'Georgia, serif', '#202020', { rotation: 180 }),
          text('537 New Los Angeles Ave.,', .17, .74, .25, .09, 'Georgia, serif', '#202020', { rotation: 180 }),
          vector('classic', [289, 328, 263, 2], .52, .22, .35, .02, 'Upper order line'),
          text('ORDER ONLINE', .52, .38, .3, .1, 'Arial, sans-serif', '#202020'),
          text('http://www.sushiplanetmoorpark.com', .52, .61, .38, .1, 'Arial, sans-serif', '#202020', { bold: true }),
          vector('classic', [289, 367, 263, 2], .52, .76, .35, .02, 'Lower order line'),
          vector('classic', [622, 329, 126, 51], .87, .5, .125, .5, 'Reverse Sushi Planet logo')
        ]
      }
    },
    modern: {
      sourceId: 'modern',
      label: 'Modern',
      description: 'The authored Moku identity, service details, and menu QR composition.',
      front: {
        background: '#ffffff',
        objects: [
          text('MOKU', .5, .40, .28, .36, 'Times New Roman, serif', '#202020'),
          text('PACIFIC PALISADES', .5, .69, .28, .11, 'Arial, sans-serif', '#202020', { bold: true, letterSpacing: .008 })
        ]
      },
      back: {
        background: '#ffffff',
        objects: [
          text('TAKEOUTS • RESERVATIONS • PARTY PLATTER', .27, .36, .44, .12, 'Arial, sans-serif', '#202020', { bold: true }),
          text('(424) 272 9339 | (424) 272 9329', .23, .66, .36, .12, 'Arial, sans-serif', '#202020'),
          text('DELIVERIES\nMENU', .77, .5, .15, .12, 'Arial, sans-serif', '#202020', { bold: true }),
          vector('modern', [674, 323, 70, 52], .88, .5, .07, .5, 'Menu QR code')
        ]
      }
    },
    simple: {
      sourceId: 'simple',
      label: 'Simple',
      description: 'The authored Masa signature mark with a restrained social reverse.',
      front: {
        background: '#ffffff',
        objects: [vector('simple', [280, 258, 283, 31], .5, .5, .36, .32, 'Masa signature logo')]
      },
      back: {
        background: '#ffffff',
        objects: [text('@masasushila', .5, .5, .36, .24, 'Arial, sans-serif', '#202020', { bold: true })]
      }
    },
    bold: {
      sourceId: 'bold',
      label: 'Bold',
      description: 'The authored Anomalia color field, oversized name, and patterned reverse.',
      front: {
        background: '#ffffff',
        objects: [
          vector('bold', [90, 255, 8, 30], .5, .5, .9, .58, 'Anomalia print field'),
          text('ANOMALIA', .23, .5, .36, .4, 'Georgia, serif', '#e7e9a8'),
          text('EATANOMALIA.COM', .83, .5, .2, .1, 'Arial, sans-serif', '#e7e9a8', { letterSpacing: .008 })
        ]
      },
      back: {
        background: '#ffffff',
        objects: [vector('bold', [83, 321, 675, 54], .5, .5, .84, .54, 'Anomalia pattern')]
      }
    },
    traditional: {
      sourceId: 'traditional',
      label: 'Traditional',
      description: 'The authored Unbelieva Bowl identity and two-sided restaurant information.',
      front: {
        background: '#ffffff',
        objects: [
          vector('traditional', [86, 248, 157, 57], .17, .5, .2, .56, 'Unbelieva Bowl logo'),
          text('972.807.2829', .82, .27, .18, .12, 'Arial, sans-serif', '#202020', { bold: true }),
          text('2160 N Coit Rd #130, Richardson, TX 75080', .8, .53, .31, .085, 'Arial, sans-serif', '#202020'),
          text('UnbelievaBowlAsianGrill.com', .8, .72, .27, .08, 'Arial, sans-serif', '#202020'),
          vector('traditional', [638, 287, 111, 15], .82, .83, .14, .15, 'Social media icons')
        ]
      },
      back: {
        background: '#ffffff',
        objects: [
          text('UnbelievaBowlAsianGrill.com', .18, .2, .28, .08, 'Arial, sans-serif', '#202020', { rotation: 180 }),
          text('2160 N Coit Rd #130, Richardson, TX 75080', .18, .42, .31, .085, 'Arial, sans-serif', '#202020', { rotation: 180 }),
          text('972.807.2829', .18, .72, .18, .12, 'Arial, sans-serif', '#202020', { bold: true, rotation: 180 }),
          vector('traditional', [83, 322, 115, 15], .18, .14, .14, .15, 'Reverse social media icons'),
          vector('traditional', [600, 326, 160, 54], .82, .5, .2, .53, 'Reverse Unbelieva Bowl logo')
        ]
      }
    },
    text: {
      sourceId: 'text',
      label: 'Text',
      description: 'The authored Bamboo location system with five detailed restaurant blocks.',
      front: {
        background: '#ffffff',
        objects: [
          text('BAMBOO 4IRPORT', .19, .28, .22, .13, 'Arial, sans-serif', '#258b3a', { bold: true }),
          text('2601 SPRINGER BOULEVARD\nLITTLE ROCK AR 72206', .19, .64, .25, .1, 'Arial, sans-serif', '#202020', { bold: true }),
          vector('text', [318, 244, 206, 62], .5, .5, .26, .6, 'Bamboo Hibachi logo'),
          text('BAMBOO 5HERWOOD', .81, .28, .24, .13, 'Arial, sans-serif', '#258b3a', { bold: true }),
          text('117 COUNTRY CLUB ROAD STE A\nSHERWOOD AR 72120\n501 - 864 - 4906', .81, .65, .26, .095, 'Arial, sans-serif', '#202020', { bold: true })
        ]
      },
      back: {
        background: '#ffffff',
        objects: [
          vector('text', [310, 318, 2, 58], .34, .5, .004, .58, 'Column divider 1'),
          vector('text', [551, 318, 2, 58], .66, .5, .004, .58, 'Column divider 2'),
          text('BAMBOO 1', .18, .27, .22, .13, 'Arial, sans-serif', '#258b3a', { bold: true }),
          text('13420 OTTER CREEK PKWY STE 2\nLITTLE ROCK AR 72211\n501 - 615 - 8500', .18, .65, .27, .095, 'Arial, sans-serif', '#202020', { bold: true }),
          text('BAMBOO 2', .5, .27, .2, .13, 'Arial, sans-serif', '#258b3a', { bold: true }),
          text('4511 CAMP ROBINSON ROAD\nNORTH LITTLE ROCK AR 72218\n501 - 916 - 9034', .5, .65, .27, .095, 'Arial, sans-serif', '#202020', { bold: true }),
          text('BAMBOO 3', .82, .27, .2, .13, 'Arial, sans-serif', '#258b3a', { bold: true }),
          text('6606 COLONEL GLENN ROAD\nLITTLE ROCK AR 72204\n501 - 406 - 7950', .82, .65, .27, .095, 'Arial, sans-serif', '#202020', { bold: true })
        ]
      }
    },
    instructional: {
      sourceId: 'instructional',
      label: 'Instructional',
      description: 'The authored Bulta K-BBQ identity and four-step dining instructions.',
      front: {
        background: '#5b5959',
        objects: [
          vector('instructional', [68, 252, 705, 2], .5, .26, .94, .02, 'Upper accent rule'),
          vector('instructional', [68, 277, 705, 2], .5, .63, .94, .02, 'Lower accent rule'),
          vector('instructional', [230, 243, 52, 49], .26, .5, .07, .5, 'Bulta mark'),
          vector('instructional', [283, 249, 260, 33], .52, .5, .35, .34, 'Bulta K-BBQ wordmark'),
          vector('instructional', [565, 243, 44, 51], .72, .5, .06, .52, 'Online order QR code')
        ]
      },
      back: {
        background: '#ffffff',
        objects: [
          vector('instructional', [143, 319, 58, 57], .13, .53, .075, .57, 'Choose instruction icon'),
          text('1. Choose', .24, .28, .14, .12, 'Arial, sans-serif', '#202020', { bold: true, align: 'left' }),
          text('from our wide selection.\nTell your server your\nchoice of marinade', .24, .64, .16, .085, 'Arial, sans-serif', '#202020', { align: 'left' }),
          vector('instructional', [294, 319, 51, 57], .35, .53, .07, .57, 'Grill instruction icon'),
          text('2. Grill', .45, .28, .13, .12, 'Arial, sans-serif', '#202020', { bold: true, align: 'left' }),
          text('30 to 60 sec. for sliced beef,\n3 to 4 min. for seafood in foil,\n2 to 3 min. for other items.', .45, .64, .19, .078, 'Arial, sans-serif', '#202020', { align: 'left' }),
          vector('instructional', [458, 319, 51, 57], .57, .53, .07, .57, 'Dip instruction icon'),
          text('3. Dip', .66, .28, .12, .12, 'Arial, sans-serif', '#202020', { bold: true, align: 'left' }),
          text('your grilled BBQ\nitems into your\ndelicious sauce.', .66, .64, .13, .085, 'Arial, sans-serif', '#202020', { align: 'left' }),
          vector('instructional', [588, 319, 51, 57], .75, .53, .07, .57, 'Love instruction icon'),
          text('4. Love', .84, .28, .12, .12, 'Arial, sans-serif', '#202020', { bold: true, align: 'left' }),
          text('Yum! Enjoy freshly\ngrilled BBQ right\noff the grill.', .84, .64, .13, .085, 'Arial, sans-serif', '#202020', { align: 'left' })
        ]
      }
    },
    locational: {
      sourceId: 'locational',
      label: 'Locational',
      description: 'The authored Daeho mark and four-location contact composition.',
      front: {
        background: '#ffffff',
        objects: [vector('locational', [361, 243, 124, 63], .5, .5, .18, .61, 'Daeho logo')]
      },
      back: {
        background: '#ffffff',
        objects: [
          text('415 563 1388', .16, .28, .2, .13, 'Arial, sans-serif', '#202020', { bold: true }),
          text('1620 Post st.\nSan Francisco, CA 94115', .16, .66, .23, .105, 'Arial, sans-serif', '#202020'),
          text('408 770 3778', .39, .28, .2, .13, 'Arial, sans-serif', '#202020', { bold: true }),
          text('217 W Calaveras Blvd.\nMilpitas, CA 95035', .39, .66, .23, .105, 'Arial, sans-serif', '#202020'),
          text('650 389 6689', .62, .28, .2, .13, 'Arial, sans-serif', '#202020', { bold: true }),
          text('213 2nd Ave.\nSan Mateo, CA 94401', .62, .66, .22, .105, 'Arial, sans-serif', '#202020'),
          text('628 895 0505', .85, .24, .2, .13, 'Arial, sans-serif', '#202020', { bold: true }),
          text('Inside H-Mart\n3995 Alemany Blvd\nSan Francisco, CA 94132', .85, .65, .23, .092, 'Arial, sans-serif', '#202020')
        ]
      }
    }
  };

  function decorateSide(recipeId, sideId, side) {
    var result = clone(side);
    result.background = { fill: result.background };
    result.objects.forEach(function (object, index) {
      object.id = 'professional-' + recipeId + '-' + sideId + '-' + (object.type === 'image' ? 'artwork' : 'text') + '-' + index;
      if (object.assetRef) object.assetRef.templateId = object.id;
      delete object.label;
    });
    return result;
  }

  function instantiate(recipeId) {
    var definition = definitions[recipeId];
    if (!definition) return null;
    return {
      front: decorateSide(recipeId, 'front', definition.front),
      back: decorateSide(recipeId, 'back', definition.back)
    };
  }

  function sourceUrl(sourceId) {
    var source = configuratorRoot.querySelector('[data-configurator-sample-source="' + sourceId + '"]');
    return source && source.getAttribute('data-configurator-sample-source-url');
  }

  function loadSource(sourceId) {
    if (sourcePromises[sourceId]) return sourcePromises[sourceId];
    sourcePromises[sourceId] = new Promise(function (resolve, reject) {
      var url = sourceUrl(sourceId);
      if (!url) {
        reject(new Error('The professional template source is unavailable.'));
        return;
      }
      var image = new Image();
      image.crossOrigin = 'anonymous';
      image.decoding = 'async';
      image.onload = function () { resolve(image); };
      image.onerror = function () { reject(new Error('The professional template source could not be loaded.')); };
      image.src = url;
    });
    return sourcePromises[sourceId];
  }

  function loadCrop(assetRef) {
    var cacheKey = assetRef.templateId + '|' + assetRef.crop.join(',');
    if (cropPromises[cacheKey]) return cropPromises[cacheKey];
    cropPromises[cacheKey] = loadSource(assetRef.sourceId).then(function (source) {
      var sourceWidth = source.naturalWidth || source.width;
      var sourceHeight = source.naturalHeight || source.height;
      var crop = assetRef.crop;
      var sourceCrop = [
        crop[0] * sourceWidth / PAGE_WIDTH,
        crop[1] * sourceHeight / PAGE_HEIGHT,
        crop[2] * sourceWidth / PAGE_WIDTH,
        crop[3] * sourceHeight / PAGE_HEIGHT
      ];
      var canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(crop[2] * CROP_SCALE));
      canvas.height = Math.max(1, Math.round(crop[3] * CROP_SCALE));
      canvas.getContext('2d').drawImage(
        source,
        sourceCrop[0], sourceCrop[1], sourceCrop[2], sourceCrop[3],
        0, 0, canvas.width, canvas.height
      );
      return {
        id: assetRef.templateId,
        element: canvas,
        type: 'image/png',
        width: canvas.width,
        height: canvas.height
      };
    });
    return cropPromises[cacheKey];
  }

  function loadForDocument(document) {
    var refs = {};
    if (document && document.sides) {
      document.sides.front.objects.concat(document.sides.back.objects).forEach(function (object) {
        if (object.type === 'image' && object.assetRef && object.assetRef.kind === 'template') {
          refs[object.assetRef.templateId] = object.assetRef;
        }
      });
    }
    return Promise.all(Object.keys(refs).map(function (assetId) {
      return loadCrop(refs[assetId]);
    })).then(function (records) {
      var assets = {};
      records.forEach(function (record) { assets[record.id] = record; });
      return assets;
    });
  }

  configuratorRoot.configuratorProfessionalTemplates = {
    version: TEMPLATE_VERSION,
    ids: Object.keys(definitions),
    getMetadata: function (recipeId) {
      var definition = definitions[recipeId];
      return definition ? { label: definition.label, description: definition.description } : null;
    },
    instantiate: instantiate,
    loadForDocument: loadForDocument
  };
}());
